import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent implements OnInit {
  constructor( private elRef: ElementRef,
    public umsService: UmsService,
    public dialogRef: MatDialogRef<MessageBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    onClose(response: boolean) {
      this.dialogRef.close(response);
    }
  ngOnInit(): void {
    let the = localStorage.getItem('theme')
  }

  SelectData(value){
    if(value == "P"){
      this.dialogRef.close();
    }
    else if(value == "E"){
      let payload = {};
      
      this.umsService.centPaper(payload).subscribe((res) => {
        if (res.status) {
          
        }
      });
    }
  }

}
